import { ArrowRight } from "lucide-react";
import { ItemRow } from "./ItemRow";

export const PullPhase = ({ items, onTogglePull, onImage, onNext }) => {
  const pulled = items.filter((i) => i.pulled).length;
  const total = items.length;
  const allPulled = total > 0 && pulled === total;
  const pct = total ? Math.round((pulled / total) * 100) : 0;

  return (
    <div className="space-y-3" data-testid="pull-phase">
      <div className="sticky top-0 z-10 -mx-4 px-4 py-3 bg-[#13132a]/95 backdrop-blur border-b border-white/[0.06]">
        <div className="flex items-baseline justify-between mb-1.5">
          <p className="text-base font-semibold text-white/90">Pull these items</p>
          <p className="text-sm font-bold text-[#FFB800]" data-testid="pull-progress-text">{pulled} of {total} pulled</p>
        </div>
        <div className="h-2 rounded-full bg-white/10 overflow-hidden">
          <div className="h-full bg-[#10B981] transition-all duration-300" style={{ width: `${pct}%` }} />
        </div>
        <p className="text-xs text-white/40 mt-1.5">Tap each item as you grab it. Items are in SKU order.</p>
      </div>

      {total === 0 ? (
        <p className="text-sm text-white/30 text-center py-8">No items to pull for this date range</p>
      ) : (
        <div className="space-y-2">
          {items.map((item) => (
            <ItemRow key={item.id} item={item} checked={!!item.pulled} onToggle={() => onTogglePull(item)} onImage={onImage} testId={`pull-item-${item.id}`} />
          ))}
        </div>
      )}

      <div className="fixed bottom-0 left-0 right-0 p-4 bg-gradient-to-t from-[#0a0a14] via-[#0a0a14] to-transparent">
        <button
          onClick={onNext}
          className={`w-full flex items-center justify-center gap-2 py-4 rounded-xl text-base font-semibold transition-colors ${
            allPulled ? "bg-[#10B981] text-white hover:bg-[#059669]" : "bg-white/[0.08] border border-white/15 text-white/80 hover:bg-white/[0.12]"
          }`}
          data-testid="pull-next-btn"
        >
          {allPulled ? "All pulled — Next: Print Labels" : `Next: Print Labels${total - pulled > 0 ? ` (${total - pulled} not pulled)` : ""}`}
          <ArrowRight className="w-5 h-5" />
        </button>
      </div>
    </div>
  );
};
